import styled, { css } from "styled-components";
import bnLight from "assets/images/banner-light.jpg";
import bnDark from "assets/images/banner-dark.jpg";
import bnMobileLight from "assets/images/banner-mobile-light.jpg";
import bnMobileDark from "assets/images/banner-mobile-dark.jpg";
import { Theme } from "interfaces/theme";
import { fonts } from "styles";

export const Content = styled.div`
  width: 50%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 500px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 414px) {
    max-width: 100%;
    padding: 0 48px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 70px;
  line-height: 58px;
  letter-spacing: -4px;
  color: #fff;
  margin-bottom: 24px;
  text-align: center;
`;

export const Text = styled.article`
  width: 100%;
  max-width: 332px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-bottom: 32px;
  transition: 1s ease;
`;

export const Credits = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 14px;
  line-height: 22px;
  color: #fff;
  position: absolute;
  bottom: 72px;
  right: 72px;
  transition: 1s ease;

  p {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  span {
    font-family: ${fonts.BentonSansBold};
  }

  @media screen and (max-width: 500px) {
    display: none;
  }
`;

export const Legend = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 13px;
  line-height: 16px;
  color: #fff;
  position: absolute;
`;

export const LegendLight = styled(Legend)`
  width: 265px;
  left: 40px;
  bottom: 32px;
`;

export const LegendDark = styled(Legend)`
  width: 265px;
  left: 40px;
  bottom: 32px;
  display: none;
`;

interface IContainer {
  mode: Theme;
}
export const Container = styled.section<IContainer>`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  background-color: #e6c1b1;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  transition: 1s ease;
  position: relative;

  ${({ mode }) =>
    mode === "light" &&
    css`
      background-image: url(${bnLight});

      ${LegendLight} {
        display: block;
      }
      ${LegendDark} {
        display: none;
      }

      @media screen and (max-width: 1024px) {
        ${Text} {
          color: #ffffff;
        }
      }

      @media screen and (max-width: 500px) {
        background-image: url(${bnMobileLight});
      }
    `}

  ${({ mode }) =>
    mode === "dark" &&
    css`
      background-image: url(${bnDark});

      ${LegendLight} {
        display: none;
      }
      ${LegendDark} {
        display: block;
      }

      @media screen and (max-width: 1024px) {
        ${Text} {
          color: #ffffff;
        }
      }

      @media screen and (max-width: 500px) {
        background-image: url(${bnMobileDark});
      }
    `}
`;
